// Function to create a new thread by optaining a threadId

import sourceUrl from "../api/Source.api";
import { auth } from "../config/firebase.config";
import { fetchWithAuth, fetchWithOptionalAuth } from "../api/fetchWithAuth";
import axiosInstance from "../api/axiosInstance";
import { getUserId } from "../utils/storageUtils";
import mixpanel from "mixpanel-browser";
import {
  ErrorEvent,
  PromptInputEvent,
  SubscribeToProClick,
  trackButtonEvent,
} from "../config/analytics";
import { v4 as uuidv4 } from "uuid";
import { invalidateCache } from "../utils/historyCache";

export async function createThread(setThreadId) {
  // Always create a fresh thread. Callers handle reuse via
  // `threadId || (await createThread(...))`.
  try {
    const response = await fetchWithOptionalAuth(`/threads`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const xSetCookieHeader = response.headers.get("x-set-cookie");

    if (xSetCookieHeader) {
      const match = xSetCookieHeader.match(/par_practice_tkn=([^;]+)/);
      if (match) {
        const parPracticeToken = match[1];
        console.log("Extracted Token:", parPracticeToken);
        localStorage.setItem("par_practice_token", parPracticeToken);
      } else {
        console.log("par_practice_tkn not found in x-set-cookie header.");
      }
    } else {
      console.log("x-set-cookie header not found.");
    }
    const responseData = await response.json();

    if (responseData.status) {
      const newThreadId = responseData.data.match(/(.*)/)[1];
      setThreadId(newThreadId);
      localStorage.setItem("current_thread_id", newThreadId);
      return newThreadId;
    } else {
      throw new Error("Thread creation failed");
    }
  } catch (error) {
    console.error("Thread creation error:", error);
    return null;
  }
}

// export async function createThread(setThreadId) {
//   alert("nsdlnflsdf")
//   const token = localStorage.getItem('token') ;
//   try {
//     const response = await fetch("https://www.modalx.ai/threads", {
//       method: "POST",
//       credentials: "include",
//       headers: {
//         "Content-Type": "application/json",
//         "Authorization":`Bearer ${token}`
//       },
//     });

//     const responseData = await response.json();

//     if (responseData.status) {
//       // setThreadId(responseData.data.match(/thread-(.*)/)[1]);
//       // return responseData.data.match(/thread-(.*)/)[1];
//       setThreadId(responseData.data.match(/(.*)/)[1]);
//       return responseData.data.match(/(.*)/)[1];
//     } else {
//       throw new Error("Thread creation failed");
//     }
//   } catch (error) {
//     console.error("Thread creation error:", error);
//     return null;
//   }
// }

// Function to find the URL in the modalX response (temporary, #todo by backend in production)
const findUrl = (msg) => {
  const urlRegex =
    /(https?:\/\/[^']*?\.(mp3|mp4|pptx|jpg|jpeg|png|txt|ppt|pdf|docx|doc))/g;
  const match = urlRegex.exec(msg);
  return match ? match[1] : null;
};

const findUrls = (msg) => {
  const urlRegex =
    /(https?:\/\/[^']*?\.(mp3|mp4|pptx|jpg|jpeg|png|txt|ppt|pdf|docx|doc))/g;
  const matches = msg.match(urlRegex); // Use match to find all occurrences
  // console.log(matches, "=============================matches===================");
  return matches ? matches : null; // Return all matches or null if no matches
};

const isUploadedImage = (url) => url && url.includes('uploads.') && url.includes('modalx.ai');
const isDailyLimitExceeded = (url) => url && url.includes('dailylimitexceeded');
const isGeneratedOutput = (url) => url && url.includes('static.modalx.ai');
const isTerminalUrl = (url) => isUploadedImage(url) || isDailyLimitExceeded(url) || isGeneratedOutput(url);
// Only modalx.ai URLs represent files we generated — external URLs in AI text are
// reference links and should never be shown as output file attachments.
const isModalXFile = (url) => url && url.includes('modalx.ai');

const getFileStatus = (url) => isTerminalUrl(url) ? "completed" : "processing";

const getMessageStatus = (urls) => {
  const modalxUrls = urls?.filter(isModalXFile);
  if (!modalxUrls || modalxUrls.length === 0) return "completed";
  return modalxUrls.every(url => isTerminalUrl(url)) ? "completed" : "processing";
};

export async function sendMessage(
  latestEntry,
  threadId,
  threadFiles,
  threadSettings,
  setThreadId,
  templateId,
  historyFiles,
  imageFormat,
  imageModel,
  imageRatio,
  videoAvatar,
  videoBackground,
  videoVoice,
  videoAvatarLanguage,
  audioLanguage,
  audioVoice,
  businessOnboardingData,
  selectedGenVideoVoice,
  selectedGenVideoLanguage,
  minDimensionPixels,
  selectedHeightForVideoGen,
  selectedWidthForVideoGen,
  // selectCaptionFontSizeForVideoGen,
  // selectCaptionFontWeightForVideoGen,
  isBoldForCaption,
  showCaption,
  captionBackgoundColor,
  captionTextColor,
  selectedAlignmentForCaption,
  selectedVarticalAlignmentForCaption,
  selectedCaptionFontForVideoGen,
  captionFontSize,
  selectedVideoGenerationPlatform,
  setCurrentStopGenerationMessageId,
  personalAvatar,
  selectedAvatarForHeygenVideo,
  selectedAvatarVoiceForHeygenVideo,
  selectedBgColorForHeygenVideo,
  captionForHeygenVideo,
  heygenVideoTitle,
  voiceEmotionForHeygen,
  voicePitchForHeygen,
  voiceSpeedForHeygen,
  heygenAvatarOffset,
  heygenAvatarScale,
  heygenAvatarStyle,
  heygenVideoPersonalAvatarImageId,
  heygenVideoWidth,
  heygenVideoHeight,
  veoVideoResolution,
  veoVideoPeopleAndFaces,
  selectedLLMModal,
  levelOfTextDetail,
  selectedTone,
  audience,
  imageSource,
  imageStyle,
  additionalInstructions,
  slideCount,
  onStreamChunk,
  onThreadResolved
) {
  let targetThreadId;

  const isLoggedIn = localStorage.getItem("isLoggedIn");
  const par_practice_token = localStorage.getItem("par_practice_token");

  if (isLoggedIn) {
    targetThreadId = threadId || (await createThread(setThreadId));
  } else {
    targetThreadId =
      threadId ||
      localStorage.getItem("current_thread_id") ||
      (await createThread(setThreadId));
  }

  if (!targetThreadId) {
    console.error("No threadId available for sending message.");
    return;
  }

  if (onThreadResolved) onThreadResolved(targetThreadId);

  const threadMatch = targetThreadId.match(/thread-(.*)/);
  if (!threadMatch) {
    console.error("Invalid threadId format:", targetThreadId);
    return;
  }
  const req_target_threadId = threadMatch[1];

  let token = localStorage.getItem("token");
  const isViUser = localStorage.getItem("isViUser") === "true";
  if (auth.currentUser && !isViUser) {
    try {
      token = await auth.currentUser.getIdToken();
      localStorage.setItem("token", token);
    } catch (e) {
      console.error("Token refresh failed:", e);
    }
  }
  const email = localStorage.getItem("userEmail");
  const userId = localStorage.getItem("userId");
  if (par_practice_token) {
    document.cookie = `par_practice_tkn=${par_practice_token}; path=/; domain=.modalx.ai; secure; SameSite=None`;
  }

  // const synthesiaVideoSettings =
  //   threadSettings.synthesiaBackground ||
  //   threadSettings.synthesiaAvatar ||
  //   threadSettings.synthesiaVoice
  //     ? {
  //         avatarId: threadSettings.synthesiaAvatar.avatarId
  //           ? threadSettings.synthesiaAvatar.avatarId
  //           : null,
  //         avatarVoiceId: threadSettings.synthesiaVoice.VoiceId
  //           ? threadSettings.synthesiaVoice.VoiceId
  //           : null,
  //         backgroundImageId: threadSettings.synthesiaBackground.imageID
  //           ? threadSettings.synthesiaBackground.imageID
  //           : null,
  //       }
  //     : null;
  const videoSettingsForDID =
    videoAvatar || videoBackground || videoVoice || videoAvatarLanguage
      ? {
          avatarId: videoAvatar ? String(videoAvatar) : null,
          backgroundImageUrl: videoBackground ? String(videoBackground) : null,
          avatarVoiceId: videoVoice ? String(videoVoice) : null,
          avatarLanguage: videoAvatarLanguage
            ? String(videoAvatarLanguage)
            : "",
          ...(personalAvatar ? { personalAvatar: true } : {}),
        }
      : null;

  // console.log(selectedGenVideoVoice, '=============selectedGenVideoVoice==========')
  // console.log(selectedGenVideoLanguage, '=============selectedGenVideoLanguage==========')

  const videoSettings = {
    // script: "Welcome to the tutorial on video generation!",
    voice: selectedGenVideoVoice ? selectedGenVideoVoice.name : null,
    voiceVolume: 0.9,
    captionFontName: selectedCaptionFontForVideoGen || null,
    captionFontSize: captionFontSize ? Number(captionFontSize) : null,
    // captionFontSize: selectCaptionFontSizeForVideoGen ? selectCaptionFontSizeForVideoGen.value : null,
    captionFontWeight: isBoldForCaption ? 700 : 400,
    captionTextColor: {
      red: captionTextColor ? captionTextColor.r : 255,
      green: captionTextColor ? captionTextColor.g : 255,
      blue: captionTextColor ? captionTextColor.b : 255,
    },
    captionTextJustification: selectedAlignmentForCaption.toUpperCase() || null,
    captionVerticalAlignment: selectedVarticalAlignmentForCaption || null,
    captionStrokeColor: {
      red: 0,
      green: 0,
      blue: 0,
    },
    captionStrokeWeight: null,
    captionBackgroundStyleType: null,
    captionBackgroundColor: {
      red: captionBackgoundColor ? captionBackgoundColor.r : null,
      green: captionBackgoundColor ? captionBackgoundColor.g : null,
      blue: captionBackgoundColor ? captionBackgoundColor.b : null,
    },
    captionBackgroundBorderRadius: null,
    captionBackgroundOpacity: captionBackgoundColor
      ? captionBackgoundColor.a
      : null,
    captionIsHidden: showCaption ? false : true,
    aspectRatio:
      selectedWidthForVideoGen && selectedHeightForVideoGen
        ? { width: selectedWidthForVideoGen, height: selectedHeightForVideoGen }
        : null,
    minDimensionPixels: minDimensionPixels ? minDimensionPixels : null,
    language: {
      languageCode: selectedGenVideoLanguage
        ? selectedGenVideoLanguage?.languageCode
        : null,
      languageName: selectedGenVideoLanguage
        ? selectedGenVideoLanguage?.languageName
        : null,
    },
  };

  const heygenVideoSetting = {
    caption: captionForHeygenVideo ? captionForHeygenVideo : false,
    title: heygenVideoTitle ? heygenVideoTitle : "Demo - New AI Studio",
    dimension: {
      width: heygenVideoWidth,
      height: heygenVideoHeight,
    },
    video_inputs: [
      {
        character: {
          type: heygenVideoPersonalAvatarImageId ? "talking_photo" : "avatar",
          // heygenVideoPersonalAvatarImageId ?  talking_photo_id : heygenVideoPersonalAvatarImageId : avatar_id: selectedAvatarForHeygenVideo?.avatar_id ,   //"Abigail_standing_office_front",
          [heygenVideoPersonalAvatarImageId ? "talking_photo_id" : "avatar_id"]:
            heygenVideoPersonalAvatarImageId ||
            selectedAvatarForHeygenVideo?.avatar_id,
          avatar_style: heygenAvatarStyle,
          scale: heygenAvatarScale,
          offset: heygenAvatarOffset,
          // matting: true,
        },
        voice: {
          type: "text",
          voice_id: selectedAvatarVoiceForHeygenVideo?.voice_id,
          speed: voiceSpeedForHeygen,
          pitch: voicePitchForHeygen,
          emotion: voiceEmotionForHeygen,
        },
        background: {
          type: "color",
          value: selectedBgColorForHeygenVideo
            ? selectedBgColorForHeygenVideo
            : "#E5E4E2",
        },
      },
    ],
  };

      const videoSettingsVeo = {
                    instances : [{ prompt : latestEntry.content}],
                    parameters : {
                              aspectRatio: veoVideoResolution?.ratio ? veoVideoResolution?.ratio : "16:9" ,
                              personGeneration: veoVideoPeopleAndFaces ? veoVideoPeopleAndFaces : "allow_all",
                              enhancePrompt: true,
                              sampleCount: 1,
                              durationSeconds:8
                    }
        }

  const imageSettings =
    imageFormat || imageModel || imageRatio
      ? {
          outputFormat: imageFormat ? imageFormat : null,
          style: imageModel ? imageModel : null,
          aspectRatio: imageRatio ? imageRatio : null,
        }
      : null;

  const audioSettings =
    audioLanguage || audioVoice
      ? {
          voice: audioVoice ? audioVoice : null,
          language: audioLanguage ? audioLanguage : null,
        }
      : null;

  // "to N slides" captures the target count in "increase from 10 slides to 12 slides";
  // if not found, take the last "N slides" occurrence (not the first, to avoid capturing the source count).
  const toSlideMatch = latestEntry?.content?.match(/\bto\s+(\d+)\s*slides?\b/i);
  const allSlideMatches = latestEntry?.content ? [...latestEntry.content.matchAll(/\b(\d+)\s*slides?\b/gi)] : [];
  const lastSlideMatch = allSlideMatches.length > 0 ? allSlideMatches[allSlideMatches.length - 1] : null;
  const effectiveSlideCount = toSlideMatch
    ? parseInt(toSlideMatch[1], 10)
    : (lastSlideMatch ? parseInt(lastSlideMatch[1], 10) : (slideCount || 12));

  const pptSettings =  {
        textMode: "generate",
        format: "presentation",
        numCards: effectiveSlideCount,
        cardSplit: "auto",
        additionalInstructions:  additionalInstructions,
        textOptions: {
        amount: levelOfTextDetail,
        tone: selectedTone,
        audience: audience
        },
        imageOptions: {
          source: imageSource,
          style: imageStyle
        }
    }

  const fileIds = threadFiles.map((file) => file.fileId || file.imageId).filter(id => id);
  // historyFiles are not included — re-sending old file IDs causes S3 NoSuchKey errors
  // because those files have already been processed and removed from S3.
  // The backend tracks previous file context from its own stored data.

  // Generate a new UUID
  const newUuid = uuidv4();
  setCurrentStopGenerationMessageId(newUuid);
  // console.log(newUuid, 'UUID generated')

  const preferredLanguage = localStorage.getItem("language") || "";

  // Detect text-generation intent (tables, plans, etc.) to prevent the AI from
  // generating a Word document when plain markdown text is expected.
  const textGenKeywords = /\b(generate a table|create a table|make a table|plan a trip|trip plan|travel plan|itinerary|plan my|plan for|plan the|plan of|outline for|schedule for|create a plan|make a plan|give me a plan|generate a plan|write a plan|create an outline|make an outline)\b/i;
  const mediaKeywords = /\b(image|photo|picture|video|audio|music|mp3|mp4|ppt|presentation|podcast|voice|song)\b/i;
  const wantsPlainText = textGenKeywords.test(latestEntry.content) && !mediaKeywords.test(latestEntry.content);
  const apiContent = wantsPlainText
    ? `${latestEntry.content}\n\n(Please respond using plain text or markdown formatting — do not generate or attach any document files.)`
    : latestEntry.content;

  const currThreadMsg = {
    id: newUuid,
    content: apiContent,
    file_ids: fileIds,
    aiModel: selectedLLMModal,
    preferred_language: preferredLanguage,
    // videoSettings: videoSettings,
    videoSettings: {
      videoType: selectedVideoGenerationPlatform === "veo" ? 4 : 3,
      ...(selectedVideoGenerationPlatform === "Avatar" && {
        typeOneVideoSettings: videoSettings,
      }),
      ...(selectedVideoGenerationPlatform === "presenter" && {
        typeTwoVideoSettings: videoSettingsForDID,
      }),
      ...(selectedVideoGenerationPlatform === "Avatar" && {
        typeThreeVideoSettings: heygenVideoSetting,
      }),
       ...(selectedVideoGenerationPlatform === 'veo' && { typeFourVideoSettings: videoSettingsVeo }),
    },
    imageSettings: imageSettings,
    pptTemplateSettings: { templateId: templateId },
    audioSettings: audioSettings,
    pptSettings:pptSettings,
    ...(businessOnboardingData !== undefined && { businessOnboardingData: businessOnboardingData }),
  };
  console.log("Sending message with isValidDetails:", businessOnboardingData);

  const useStreaming = selectedLLMModal && selectedLLMModal.startsWith('grok-');
  
  if (useStreaming && isLoggedIn) {
    try {
      const wsProtocol = sourceUrl.startsWith('https') ? 'wss:' : 'ws:';
      const wsHost = sourceUrl.replace(/^https?:\/\//, '').replace(/\/api\/?$/, '');
      const wsUrl = `${wsProtocol}//${wsHost}/api/threads/thread-${req_target_threadId}/message/stream?token=${token}`;

      return new Promise((resolve, reject) => {
        const ws = new WebSocket(wsUrl);
        _activeWs = ws;
        _streamStopped = false;
        let finalResponse = null;
        let streamedContent = "";
        let isFirstChunk = true;

        ws.onopen = () => {
          ws.send(JSON.stringify(currThreadMsg));
        };

        ws.onmessage = (event) => {
          if (_streamStopped) return;
          try {
            const data = JSON.parse(event.data);

            switch (data.event) {
              case "chunk":
                if (data.data && data.data.content) {
                  streamedContent += data.data.content;
                  if (onStreamChunk) {
                    onStreamChunk(streamedContent, isFirstChunk, newUuid);
                    isFirstChunk = false;
                  }
                }
                break;
              case "response":
                finalResponse = data.data;
                break;
              case "complete":
                _activeWs = null;
                const content = finalResponse?.content?.content || finalResponse?.content || streamedContent;
                const urls = [...new Set(findUrls(content))];
                const currMsg = {
                  sender: "modalX",
                  content: content,
                  status: getMessageStatus(urls),
                  file: urls?.filter(isModalXFile).length > 0 ? urls.filter(isModalXFile).map((url) => ({ url: url, status: getFileStatus(url) })) : null,
                  id: finalResponse?.id || data.request_id,
                  action: finalResponse?.action || null,
                  citations: finalResponse?.citations,
                  settings_data: finalResponse?.settings_data,
                  is_stop: finalResponse?.is_stop,
                  unique_id: finalResponse?.unique_id || newUuid,
                  isStreaming: false,
                };
                PromptInputEvent("Prompt Input Event", "Prompt Input Search", currThreadMsg, { status: true, data: finalResponse });
                // Invalidate cache so next sidebar click fetches fresh data
                invalidateCache(localStorage.getItem('current_history_id'));
                resolve(currMsg);
                break;
              case "error":
                console.error("WebSocket stream error:", data.data);
                reject(new Error(data.data?.message || "Stream error"));
                break;
              default:
                break;
            }
          } catch (e) {
            console.error("WebSocket message parse error:", e);
          }
        };

        ws.onerror = (error) => {
          console.error("WebSocket error:", error);
          reject(error);
        };

        ws.onclose = (event) => {
          if (_streamStopped) {
            resolve(null); // Stopped deliberately — caller should check wasStoppedRef
          } else if (!finalResponse && !event.wasClean) {
            reject(new Error("WebSocket closed unexpectedly"));
          }
        };
      });
    } catch (error) {
      console.error("WebSocket streaming failed, falling back to HTTP:", error);
    }
  }

  try {
    const response = await fetchWithOptionalAuth(
      `/threads/thread-${req_target_threadId}/message`,
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(currThreadMsg),
      }
    );

    const responseData = await response.json();
    PromptInputEvent(
      "Prompt Input Event",
      "Prompt Input Search",
      currThreadMsg,
      responseData
    );
    if (responseData.status) {
      const content = responseData.data.content;

      const urls = [...new Set(findUrls(content))];
      const currMsg = {
        sender: "modalX",
        content: content,
        status: getMessageStatus(urls),
        file:
          urls?.filter(isModalXFile).length > 0
            ? urls.filter(isModalXFile).map((url) => ({ url: url, status: getFileStatus(url) }))
            : null,
        id: responseData.data.id ? responseData.data.id : null,
        action: responseData.data.action ? responseData.data.action : null,
        citations: responseData.data?.citations,
        settings_data: responseData.data?.settings_data,
        is_stop: responseData.data?.is_stop,
        unique_id: responseData.data?.unique_id
          ? responseData.data?.unique_id
          : newUuid,
      };
      invalidateCache(localStorage.getItem('current_history_id'));
      return currMsg;
    } else {
      await InvokeMatrixApi(
        responseData?.error,
        response,
        "POST",
        targetThreadId,
        "message",
        currThreadMsg,
        userId
      );
      return null;
    }
  } catch (error) {
    await InvokeMatrixApi(
      error,
      "",
      "POST",
      targetThreadId,
      "message",
      currThreadMsg,
      userId
    );
    ErrorEvent(error, error.message);
    return null;
  }
}

// Holds the active WebSocket so it can be closed on stop
let _activeWs = null;
let _streamStopped = false;
export const isStreamStopped = () => _streamStopped;
export const closeActiveStream = () => {
  _streamStopped = true;
  if (_activeWs && (_activeWs.readyState === WebSocket.OPEN || _activeWs.readyState === WebSocket.CONNECTING)) {
    _activeWs.close();
  }
  _activeWs = null;
};

export function sendMessageStream(
  latestEntry,
  threadId,
  threadFiles,
  threadSettings,
  setThreadId,
  templateId,
  historyFiles,
  imageFormat,
  imageModel,
  imageRatio,
  videoAvatar,
  videoBackground,
  videoVoice,
  videoAvatarLanguage,
  audioLanguage,
  audioVoice,
  businessOnboardingData,
  selectedGenVideoVoice,
  selectedGenVideoLanguage,
  minDimensionPixels,
  selectedHeightForVideoGen,
  selectedWidthForVideoGen,
  isBoldForCaption,
  showCaption,
  captionBackgoundColor,
  captionTextColor,
  selectedAlignmentForCaption,
  selectedVarticalAlignmentForCaption,
  selectedCaptionFontForVideoGen,
  captionFontSize,
  selectedVideoGenerationPlatform,
  setCurrentStopGenerationMessageId,
  personalAvatar,
  selectedAvatarForHeygenVideo,
  selectedAvatarVoiceForHeygenVideo,
  selectedBgColorForHeygenVideo,
  captionForHeygenVideo,
  heygenVideoTitle,
  voiceEmotionForHeygen,
  voicePitchForHeygen,
  voiceSpeedForHeygen,
  heygenAvatarOffset,
  heygenAvatarScale,
  heygenAvatarStyle,
  heygenVideoPersonalAvatarImageId,
  heygenVideoWidth,
  heygenVideoHeight,
  veoVideoResolution,
  veoVideoPeopleAndFaces,
  selectedLLMModal,
  levelOfTextDetail,
  selectedTone,
  audience,
  imageSource,
  imageStyle,
  additionalInstructions,
  slideCount,
  onChunk,
  onComplete,
  onError
) {
  return new Promise(async (resolve, reject) => {
    try {
      const isLoggedIn = localStorage.getItem("isLoggedIn");
      let token = localStorage.getItem("token");
      const isViUser = localStorage.getItem("isViUser") === "true";
      if (auth.currentUser && !isViUser) {
        try {
          token = await auth.currentUser.getIdToken();
          localStorage.setItem("token", token);
        } catch (e) {
          console.error("Token refresh failed:", e);
        }
      }

      let targetThreadId = threadId;
      if (!targetThreadId) {
        if (isLoggedIn) {
          targetThreadId = await createThread(setThreadId);
        } else {
          targetThreadId = localStorage.getItem("current_thread_id") || await createThread(setThreadId);
        }
      }
      
      const req_target_threadId = targetThreadId.match(/thread-(.*)/)[1];
      
      const wsProtocol = sourceUrl.startsWith('https') ? 'wss:' : 'ws:';
      const wsHost = sourceUrl.replace(/^https?:\/\//, '').replace(/\/api\/?$/, '');
      const wsUrl = `${wsProtocol}//${wsHost}/api/threads/thread-${req_target_threadId}/message/stream?token=${token}`;

      const ws = new WebSocket(wsUrl);
      _activeWs = ws;
      _streamStopped = false;
      let fullContent = "";
      let finalResponse = null;

      const videoSettingsForDID = videoAvatar || videoBackground || videoVoice || videoAvatarLanguage ? {
        avatarId: videoAvatar ? String(videoAvatar) : null,
        backgroundImageUrl: videoBackground ? String(videoBackground) : null,
        avatarVoiceId: videoVoice ? String(videoVoice) : null,
        avatarLanguage: videoAvatarLanguage ? String(videoAvatarLanguage) : "",
        ...(personalAvatar ? { personalAvatar: true } : {}),
      } : null;

      const videoSettings = {
        voice: selectedGenVideoVoice ? selectedGenVideoVoice.name : null,
        voiceVolume: 0.9,
        captionFontName: selectedCaptionFontForVideoGen || null,
        captionFontSize: captionFontSize ? Number(captionFontSize) : null,
        captionFontWeight: isBoldForCaption ? 700 : 400,
        captionTextColor: { red: captionTextColor ? captionTextColor.r : 255, green: captionTextColor ? captionTextColor.g : 255, blue: captionTextColor ? captionTextColor.b : 255 },
        captionTextJustification: selectedAlignmentForCaption?.toUpperCase() || null,
        captionVerticalAlignment: selectedVarticalAlignmentForCaption || null,
        captionStrokeColor: { red: 0, green: 0, blue: 0 },
        captionBackgroundColor: { red: captionBackgoundColor ? captionBackgoundColor.r : null, green: captionBackgoundColor ? captionBackgoundColor.g : null, blue: captionBackgoundColor ? captionBackgoundColor.b : null },
        captionBackgroundOpacity: 0.5,
        language: selectedGenVideoLanguage || {},
      };

      const heygenVideoSettings = {
        caption: captionForHeygenVideo || false,
        title: heygenVideoTitle || "",
        video_inputs: [{
          character: {
            type: "avatar",
            avatar_id: selectedAvatarForHeygenVideo || "",
            scale: heygenAvatarScale || 1,
            offset: heygenAvatarOffset || { x: 0, y: 0 }
          },
          voice: {
            type: "text",
            voice_id: selectedAvatarVoiceForHeygenVideo || "",
            speed: voiceSpeedForHeygen || 1,
            emotion: voiceEmotionForHeygen || "Friendly"
          },
          background: { type: "color", value: selectedBgColorForHeygenVideo || "#FFFFFF" }
        }],
        dimension: { width: heygenVideoWidth || 1280, height: heygenVideoHeight || 720 }
      };

      const veoVideoSettings = {
        instances: null,
        parameters: {
          aspectRatio: veoVideoResolution || "",
          negativePrompt: "",
          personGeneration: veoVideoPeopleAndFaces || "",
          sampleCount: 0,
          durationSeconds: 0,
          enhancePrompt: false
        }
      };

      // "to N slides" captures the target count in "increase from 10 slides to 12 slides";
      // if not found, take the last "N slides" occurrence (not the first, to avoid capturing the source count).
      const toSlideMatchWs = latestEntry?.content?.match(/\bto\s+(\d+)\s*slides?\b/i);
      const allSlideMatchesWs = latestEntry?.content ? [...latestEntry.content.matchAll(/\b(\d+)\s*slides?\b/gi)] : [];
      const lastSlideMatchWs = allSlideMatchesWs.length > 0 ? allSlideMatchesWs[allSlideMatchesWs.length - 1] : null;
      const effectiveSlideCountWs = toSlideMatchWs
        ? parseInt(toSlideMatchWs[1], 10)
        : (lastSlideMatchWs ? parseInt(lastSlideMatchWs[1], 10) : (slideCount || 12));

      const pptSettings = {
        textMode: "generate",
        format: "presentation",
        numCards: effectiveSlideCountWs,
        cardSplit: "auto",
        additionalInstructions: additionalInstructions || "",
        textOptions: { amount: levelOfTextDetail || "medium", tone: selectedTone || "professional", audience: audience || "business executives" },
        imageOptions: { source: imageSource || "aiGenerated", style: imageStyle || "modern professional" }
      };

      const preferredLanguage = localStorage.getItem("language") || "";

      const textGenKeywordsWs = /\b(generate a table|create a table|make a table|plan a trip|trip plan|travel plan|itinerary|plan my|plan for|plan the|plan of|outline for|schedule for|create a plan|make a plan|give me a plan|generate a plan|write a plan|create an outline|make an outline)\b/i;
      const mediaKeywordsWs = /\b(image|photo|picture|video|audio|music|mp3|mp4|ppt|presentation|podcast|voice|song)\b/i;
      const wantsPlainTextWs = textGenKeywordsWs.test(latestEntry.content) && !mediaKeywordsWs.test(latestEntry.content);
      const apiContentWs = wantsPlainTextWs
        ? `${latestEntry.content}\n\n(Please respond using plain text or markdown formatting — do not generate or attach any document files.)`
        : latestEntry.content;

      const currThreadMsg = {
        id: crypto.randomUUID(),
        content: apiContentWs,
        file_ids: threadFiles.map((file) => file.fileId || file.imageId).filter(id => id),
        imageSettings: { aspectRatio: imageRatio || "16:9", style: imageFormat || "photographic" },
        audioSettings: { voice: audioVoice || "", language: audioLanguage || "" },
        videoSettings: {
          videoType: selectedVideoGenerationPlatform || 3,
          typeOneVideoSettings: videoSettings,
          typeTwoVideoSettings: videoSettingsForDID,
          typeThreeVideoSettings: heygenVideoSettings,
          typeFourVideoSettings: veoVideoSettings
        },
        pptSettings: pptSettings,
        aiModel: selectedLLMModal || "openai/gpt-5.2-chat",
        preferred_language: preferredLanguage,
        ...(businessOnboardingData !== undefined && { businessOnboardingData: businessOnboardingData }),
      };

      ws.onopen = () => {
        ws.send(JSON.stringify(currThreadMsg));
      };

      ws.onmessage = (event) => {
        if (_streamStopped) return;
        try {
          const data = JSON.parse(event.data);
          
          switch (data.event) {
            case "chunk":
              if (data.data && data.data.content) {
                fullContent += data.data.content;
                if (onChunk) onChunk(data.data.content, fullContent);
              }
              break;
            case "tool_call":
              break;
            case "response":
              finalResponse = data.data;
              break;
            case "complete":
              _activeWs = null;
              const urls = [...new Set(findUrls(finalResponse?.content || fullContent))];
              const result = {
                sender: "modalX",
                content: finalResponse?.content || fullContent,
                status: getMessageStatus(urls),
                file: urls?.filter(isModalXFile).length > 0 ? urls.filter(isModalXFile).map((url) => ({ url: url, status: getFileStatus(url) })) : null,
                id: finalResponse?.id || data.request_id,
                action: finalResponse?.action || null,
                citations: finalResponse?.citations,
                settings_data: finalResponse?.settings_data,
                is_stop: finalResponse?.is_stop,
                unique_id: finalResponse?.unique_id || currThreadMsg.id,
              };
              if (onComplete) onComplete(result);
              resolve(result);
              break;
            case "error":
              const errorMsg = data.data?.message || "Stream error";
              if (onError) onError(errorMsg);
              reject(new Error(errorMsg));
              break;
            default:
              break;
          }
        } catch (e) {
          console.error("WebSocket message parse error:", e);
        }
      };

      ws.onerror = (error) => {
        console.error("WebSocket error:", error);
        if (onError) onError("WebSocket connection error");
        reject(error);
      };

      ws.onclose = (event) => {
        if (!finalResponse && !event.wasClean) {
          if (onError) onError("WebSocket closed unexpectedly");
        }
      };

    } catch (error) {
      if (onError) onError(error.message);
      reject(error);
    }
  });
}

export async function submitChallenge(
  latestEntry,
  threadId,
  threadFiles,
  threadSettings,
  setThreadId,
  templateId,
  historyFiles,
  imageFormat,
  imageModel,
  imageRatio,
  videoAvatar,
  videoBackground,
  videoVoice,
  videoAvatarLanguage,
  audioLanguage,
  audioVoice,
  businessOnboardingData,
  selectedGenVideoVoice,
  selectedGenVideoLanguage,
  minDimensionPixels,
  selectedHeightForVideoGen,
  selectedWidthForVideoGen,
  // selectCaptionFontSizeForVideoGen,
  // selectCaptionFontWeightForVideoGen,
  isBoldForCaption,
  showCaption,
  captionBackgoundColor,
  captionTextColor,
  selectedAlignmentForCaption,
  selectedVarticalAlignmentForCaption,
  selectedCaptionFontForVideoGen,
  captionFontSize,
  selectedVideoGenerationPlatform
) {
  const targetThreadId = threadId || (await createThread(setThreadId));
  const req_target_threadId = targetThreadId.match(/thread-(.*)/)[1];
  const userId = getUserId();
  console.log("inside send message", threadId);
  if (!targetThreadId) {
    console.error("No threadId available for sending message.");
    return;
  }

  // const synthesiaVideoSettings =
  //   threadSettings.synthesiaBackground ||
  //   threadSettings.synthesiaAvatar ||
  //   threadSettings.synthesiaVoice
  //     ? {
  //         avatarId: threadSettings.synthesiaAvatar.avatarId
  //           ? threadSettings.synthesiaAvatar.avatarId
  //           : null,
  //         avatarVoiceId: threadSettings.synthesiaVoice.VoiceId
  //           ? threadSettings.synthesiaVoice.VoiceId
  //           : null,
  //         backgroundImageId: threadSettings.synthesiaBackground.imageID
  //           ? threadSettings.synthesiaBackground.imageID
  //           : null,
  //       }
  //     : null;
  const videoSettingsForDID =
    videoAvatar || videoBackground || videoVoice || videoAvatarLanguage
      ? {
          avatarId: videoAvatar ? String(videoAvatar) : null,
          backgroundImageUrl: videoBackground ? String(videoBackground) : null,
          avatarVoiceId: videoVoice ? String(videoVoice) : null,
          avatarLanguage: videoAvatarLanguage
            ? String(videoAvatarLanguage)
            : "",
        }
      : null;

  // console.log(selectedGenVideoVoice, '=============selectedGenVideoVoice==========')
  // console.log(selectedGenVideoLanguage, '=============selectedGenVideoLanguage==========')

  const videoSettings = {
    // script: "Welcome to the tutorial on video generation!",
    voice: selectedGenVideoVoice ? selectedGenVideoVoice.name : null,
    voiceVolume: 0.9,
    captionFontName: selectedCaptionFontForVideoGen || null,
    captionFontSize: captionFontSize ? Number(captionFontSize) : null,
    // captionFontSize: selectCaptionFontSizeForVideoGen ? selectCaptionFontSizeForVideoGen.value : null,
    captionFontWeight: isBoldForCaption ? 700 : 400,
    captionTextColor: {
      red: captionTextColor ? captionTextColor.r : 255,
      green: captionTextColor ? captionTextColor.g : 255,
      blue: captionTextColor ? captionTextColor.b : 255,
    },
    captionTextJustification: selectedAlignmentForCaption.toUpperCase() || null,
    captionVerticalAlignment: selectedVarticalAlignmentForCaption || null,
    captionStrokeColor: {
      red: 0,
      green: 0,
      blue: 0,
    },
    captionStrokeWeight: null,
    captionBackgroundStyleType: null,
    captionBackgroundColor: {
      red: captionBackgoundColor ? captionBackgoundColor.r : null,
      green: captionBackgoundColor ? captionBackgoundColor.g : null,
      blue: captionBackgoundColor ? captionBackgoundColor.b : null,
    },
    captionBackgroundBorderRadius: null,
    captionBackgroundOpacity: captionBackgoundColor
      ? captionBackgoundColor.a
      : null,
    captionIsHidden: showCaption ? false : true,
    aspectRatio:
      selectedWidthForVideoGen && selectedHeightForVideoGen
        ? { width: selectedWidthForVideoGen, height: selectedHeightForVideoGen }
        : null,
    minDimensionPixels: minDimensionPixels ? minDimensionPixels : null,
    language: {
      languageCode: selectedGenVideoLanguage
        ? selectedGenVideoLanguage?.languageCode
        : null,
      languageName: selectedGenVideoLanguage
        ? selectedGenVideoLanguage?.languageName
        : null,
    },
  };

  const imageSettings =
    imageFormat || imageModel || imageRatio
      ? {
          outputFormat: imageFormat ? imageFormat : null,
          style: imageModel ? imageModel : null,
          aspectRatio: imageRatio ? imageRatio : null,
        }
      : null;

  const audioSettings =
    audioLanguage || audioVoice
      ? {
          voice: audioVoice ? audioVoice : null,
          language: audioLanguage ? audioLanguage : null,
        }
      : null;

  const fileIds = threadFiles.map((file) => file.fileId || file.imageId).filter(id => id);
  // historyFiles are not included — re-sending old file IDs causes S3 NoSuchKey errors.

  const textGenKeywordsSm = /\b(generate a table|create a table|make a table|plan a trip|trip plan|travel plan|itinerary|plan my|plan for|plan the|plan of|outline for|schedule for|create a plan|make a plan|give me a plan|generate a plan|write a plan|create an outline|make an outline)\b/i;
  const mediaKeywordsSm = /\b(image|photo|picture|video|audio|music|mp3|mp4|ppt|presentation|podcast|voice|song)\b/i;
  const wantsPlainTextSm = textGenKeywordsSm.test(latestEntry.content) && !mediaKeywordsSm.test(latestEntry.content);
  const apiContentSm = wantsPlainTextSm
    ? `${latestEntry.content}\n\n(Please respond using plain text or markdown formatting — do not generate or attach any document files.)`
    : latestEntry.content;

  const currThreadMsg = {
    content: apiContentSm,
    file_ids: fileIds,
    // videoSettings: videoSettings,
    videoSettings: {
      videoType: selectedVideoGenerationPlatform === "Avatar" ? 1 : 2,
      ...(selectedVideoGenerationPlatform === "Avatar" && {
        typeOneVideoSettings: videoSettings,
      }),
      ...(selectedVideoGenerationPlatform === "presenter" && {
        typeTwoVideoSettings: videoSettingsForDID,
      }),
    },
    imageSettings: imageSettings,
    pptTemplateSettings: { templateId: templateId },
    audioSettings: audioSettings,
    ...(businessOnboardingData !== undefined && { businessOnboardingData: businessOnboardingData }),
  };
  console.log("Sending message with isValidDetails:", businessOnboardingData);

  try {
    const response = await fetchWithAuth(
      `/threads/thread-${req_target_threadId}/messages/challenges/submit`,
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(currThreadMsg),
      }
    );

    const responseData = await response.json();
    // if(responseData.sender ==='modalX'){
    //   const content = responseData.content;
    //   const url = findUrl(content);
    //   const currMsg = {
    //     sender: "modalX",
    //     content: content,
    //     file: url ? { url: url, status: "processing" } : null,
    //   };
    //   return currMsg;
    // }
    PromptInputEvent(
      "Prompt Input Event",
      "Prompt Input Search",
      currThreadMsg,
      responseData
    );
    if (responseData.status) {
      // ==========================Invoke matrix api ===================================================
      // Invoke matrix API
      await InvokeMatrixApi(
        responseData,
        response,
        "POST",
        targetThreadId,
        "message",
        currThreadMsg,
        userId
      );
      // ===============================================================================================
      const content = responseData.data.content;
      // const url = findUrl(content);
      // const currMsg = {
      //   sender: "modalX",
      //   content: content,
      //   file: url ? { url: url, status: "processing" } : null,
      // };

      const urls = findUrls(content);
      // const currMsg = {
      //   sender: "modalX",
      //   content: content,
      //   file: urls ? { urls: urls, status: "processing" } : null,
      // };
      const currMsg = {
        sender: "modalX",
        content: content,
        status: getMessageStatus(urls),
        file:
          urls?.filter(isModalXFile).length > 0
            ? urls.filter(isModalXFile).map((url) => ({ url: url, status: getFileStatus(url) }))
            : null,
        id: responseData.data.id ? responseData.data.id : null,
        action: responseData.data.action ? responseData.data.action : null,
        citations: responseData.data?.citations,
        settings_data: responseData.data?.settings_data,
      };
      // alert("dnsfnjsknj")
      return currMsg;
    } else {
      // alert(email)
      // console.error("Failed to process messageeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee:", responseData?.error);
      await InvokeMatrixApi(
        responseData?.error,
        "",
        "POST",
        targetThreadId,
        "message",
        currThreadMsg,
        userId
      );
      // PromptInputEvent("Prompt Input Event", "Prompt Input Search", currThreadMsg, responseData)
      return null;
    }
  } catch (error) {
    // ==========================Invoke matrix api ===================================================
    // Invoke matrix API
    await InvokeMatrixApi(
      error,
      "",
      "POST",
      targetThreadId,
      "message",
      currThreadMsg,
      userId
    );
    // ===============================================================================================
    ErrorEvent(error, error.message);
    return null;
  }
}

export async function getChallenges(
  latestEntry,
  isValidDetails,
  businessOnboardingData,
  threadId,
  setThreadId
) {
  const targetThreadId = threadId || (await createThread(setThreadId));
  const req_target_threadId = targetThreadId.match(/thread-(.*)/)[1];
  const userId = getUserId();
  console.log("inside send message", threadId);
  if (!targetThreadId) {
    console.error("No threadId available for sending message.");
    return;
  }

  const currThreadMsg = {
    content: latestEntry.content,
    isValidDetails: isValidDetails,
    ...(businessOnboardingData !== undefined && { userInfo: businessOnboardingData }),
  };
  console.log("Sending message with isValidDetails:", businessOnboardingData);

  try {
    const response = await fetchWithAuth(
      `/threads/thread-${req_target_threadId}/messages/challenges`,
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(currThreadMsg),
      }
    );

    const responseData = await response.json();
    // if(responseData.sender ==='modalX'){
    //   const content = responseData.content;
    //   const url = findUrl(content);
    //   const currMsg = {
    //     sender: "modalX",
    //     content: content,
    //     file: url ? { url: url, status: "processing" } : null,
    //   };
    //   return currMsg;
    // }
    PromptInputEvent(
      "Prompt Input Event",
      "Prompt Input Search",
      currThreadMsg,
      responseData
    );
    if (responseData.status) {
      // ==========================Invoke matrix api ===================================================
      // Invoke matrix API
      await InvokeMatrixApi(
        responseData,
        response,
        "POST",
        targetThreadId,
        "message",
        currThreadMsg,
        userId
      );
      // ===============================================================================================
      const content = responseData.data.content;
      // const url = findUrl(content);
      // const currMsg = {
      //   sender: "modalX",
      //   content: content,
      //   file: url ? { url: url, status: "processing" } : null,
      // };

      const urls = findUrls(content);
      // const currMsg = {
      //   sender: "modalX",
      //   content: content,
      //   file: urls ? { urls: urls, status: "processing" } : null,
      // };
      const currMsg = {
        sender: "modalX",
        content: content,
        status: getMessageStatus(urls),
        file:
          urls?.filter(isModalXFile).length > 0
            ? urls.filter(isModalXFile).map((url) => ({ url: url, status: getFileStatus(url) }))
            : null,
        id: responseData.data.id ? responseData.data.id : null,
        action: responseData.data.action ? responseData.data.action : null,
        citations: responseData.data?.citations,
        settings_data: responseData.data?.settings_data,
      };
      // alert("dnsfnjsknj")
      return currMsg;
    } else {
      // alert(email)
      // console.error("Failed to process messageeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee:", responseData?.error);
      await InvokeMatrixApi(
        responseData?.error,
        "",
        "POST",
        targetThreadId,
        "message",
        currThreadMsg,
        userId
      );
      // PromptInputEvent("Prompt Input Event", "Prompt Input Search", currThreadMsg, responseData)
      return null;
    }
  } catch (error) {
    // ==========================Invoke matrix api ===================================================
    // Invoke matrix API
    await InvokeMatrixApi(
      error,
      "",
      "POST",
      targetThreadId,
      "message",
      currThreadMsg,
      userId
    );
    // ===============================================================================================
    ErrorEvent(error, error.message);
    return null;
  }
}

export async function InvokeOnBoardingStatusAPI() {
  try {
    const response = await axiosInstance.get(`/user/businessOnboardingStatus`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response?.data.data;
  } catch (error) {}
}

export async function checkUrlStatus(url, threadId) {
  console.log("here is the threadid and url ", threadId, url);
  const email = localStorage.getItem("userEmail");
  try {
    const response = await fetchWithAuth(`/status`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ threadId, url }),
    });

    const responseData = await response.json();
    // console.log("zzzzzzzzzzzzzzzzzzzz",responseData)
    if (response.status === 200) {
      if (
        responseData.data.status === "completed" ||
        responseData.data.status === "failed"
      ) {
        return true;
      } else {
        return false;
      }
    } else if (response.status === 500) {
      return null;
    }
    // ==========================Invoke matrix api ===================================================
    // Invoke matrix API
    await InvokeMatrixApi(responseData, response, "POST", threadId, "status", {
      threadId,
      url,
      userId: email,
    });
    // ===============================================================================================
  } catch (error) {
    // ==========================Invoke matrix api ===================================================
    // Invoke matrix API
    await InvokeMatrixApi(error, error.data, "POST", threadId, "status", {
      threadId,
      url,
    });
    // ===============================================================================================
    console.error("Check URL status request error:", error);
    return null;
  }
}

export const InvokeMatrixApi = async (
  jsonRespData,
  respData,
  reqType,
  threadId,
  endPoint,
  reqBody,
  userId
) => {
  // const targetThreadId = threadId || (await createThread(setThreadId));
  const targetThreadId = threadId || localStorage.getItem("threadId");
  try {
    const data = {
      url: endPoint,
      threadId: targetThreadId,
      requestId: jsonRespData?.requestID || "",
      requestType: reqType,
      requestBody: reqBody || {},
      responseBody: jsonRespData || {},
      responseCode: respData?.status || 0,
      userId: userId || "",
    };

    const headers = {
      "Content-Type": "application/json",
    };

    const matrix_Res = await fetchWithAuth(`/add`, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(data),
    });
    // console.log("hhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh",matrix_Res)
  } catch (error) {
    console.error("Error making the POST request:", error);
  }
};

export async function uploadFiles(fileObj, threadId, setThreadId) {
  const targetThreadId = threadId || (await createThread(setThreadId));
  if (!targetThreadId) {
    console.error("No threadId available for uploading files.");
    return null;
  }

  const formData = new FormData();
  if (fileObj.type === "link") {
    formData.append("link", fileObj.link);
  } else if (fileObj.type === "file") {
    formData.append("file", fileObj.file);
  }

  try {
    const response = await fetchWithAuth(
      `/threads/fileupload?threadId=${targetThreadId}`,
      {
        method: "POST",
        credentials: "include",
        body: formData,
      }
    );
    const responseData = await response.json();
    // ==========================Invoke matrix api ===================================================
    const reqBody = {};
    if (fileObj.type === "link") {
      reqBody.link = fileObj.link;
    } else if (fileObj.type === "file") {
      reqBody.file = fileObj.file.name; // Pass the file name instead of the file object
    }

    // Invoke matrix API
    await InvokeMatrixApi(
      responseData,
      response,
      "POST",
      targetThreadId,
      "fileupload",
      reqBody
    );
    // ===============================================================================================
    console.log("response dataaaaaaaaaaaaaaa", responseData);
    return responseData;
    // return await response.json(); // Return the entire response object
  } catch (error) {
    console.error("Upload file request Error:", error);
    // ==========================Invoke matrix api ===================================================
    const reqBody = {};
    if (fileObj.type === "link") {
      reqBody.link = fileObj.link;
    } else if (fileObj.type === "file") {
      reqBody.file = fileObj.file.name; // Pass the file name instead of the file object
    }

    // Invoke matrix API
    await InvokeMatrixApi(
      error,
      error.data,
      "POST",
      targetThreadId,
      "fileupload",
      reqBody
    );
    // ===============================================================================================
    return null;
  }
}

export async function upload_FilesOnly(fileObj, threadId, setThreadId) {
  const targetThreadId = threadId || (await createThread(setThreadId));
  const userId = localStorage.getItem("userId");

  if (!targetThreadId) {
    console.error("No threadId available for uploading files.");
    return null;
  }

  const formData = new FormData();
  if (fileObj.type === "link") {
    formData.append("link", fileObj.link);
  } else if (fileObj.type === "file") {
    formData.append("file", fileObj.file);
  }

  try {
    const response = await fetchWithAuth(
      `/threads/upload?threadId=${targetThreadId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({ name: fileObj.file.name }),
      }
    );

    const responseData = await response.json();

    // Check if the upload to /upload was successful
    if (responseData.status) {
      // Assign fileId to fileObj.file.fileId
      fileObj.file.fileId = responseData.data.id;

      // Upload the file to the provided S3 URL
      await uploadToS3(responseData.data.url, fileObj.file);

      // Update upload status and return its response
      const uploadStatusResponse = await uploadStatus(
        targetThreadId,
        fileObj.file
      );

      // Invoke matrix API with appropriate data
      const reqBody = {
        file: fileObj.file.name, // Adjust as per your matrix API requirements
      };
      await InvokeMatrixApi(
        responseData,
        response,
        "POST",
        targetThreadId,
        "fileupload",
        reqBody,
        userId
      );

      return uploadStatusResponse; // Return the response from uploadStatus
    } else {
      console.error("Failed to upload file:", responseData);
      await InvokeMatrixApi(
        responseData,
        response,
        "POST",
        targetThreadId,
        "fileupload",
        {},
        userId
      );
      return null;
    }
  } catch (error) {
    console.error("Upload file request Error:", error);

    // Invoke matrix API with error details
    const reqBody = {
      error: error.message, // Example, adjust as per your matrix API requirements
    };
    await InvokeMatrixApi(
      error,
      error.data,
      "POST",
      targetThreadId,
      "fileupload",
      reqBody,
      userId
    );

    return null;
  }
}

export function isImageFile(file) {
  const imageTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp', 'image/heic', 'image/heif'];
  return file && file.type && imageTypes.includes(file.type.toLowerCase());
}

export async function uploadImages(files, threadId, setThreadId, messageId = null) {
  const targetThreadId = threadId || (await createThread(setThreadId));

  if (!targetThreadId) {
    console.error("No threadId available for uploading images.");
    return null;
  }

  const numericThreadId = targetThreadId.match(/thread-(.*)/)?.[1] || targetThreadId;

  const formData = new FormData();
  formData.append("thread_id", numericThreadId);
  if (messageId) {
    formData.append("message_id", messageId);
  }
  
  files.forEach((file) => {
    formData.append("files", file);
  });

  try {
    const response = await fetchWithAuth(`/images/upload`, {
      method: "POST",
      credentials: "include",
      body: formData,
    });

    const responseData = await response.json();
    
    if (responseData.status) {
      return responseData.data;
    } else {
      console.error("Failed to upload images:", responseData);
      return null;
    }
  } catch (error) {
    console.error("Upload images request Error:", error);
    return null;
  }
}

async function uploadToS3(url, file) {
  try {
    await fetch(url, {
      method: 'PUT',
      headers: {
        "Content-Type": file.type,
      },
      body: file,
    });
    console.log("File uploaded to S3 successfully");
  } catch (error) {
    console.error("Error uploading file to S3:", error);
    throw error;
  }
}

async function uploadStatus(threadId, file) {
  try {
    const statusResponse = await fetchWithAuth(
      `/threads/uploadStatus?threadId=${threadId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: file.fileId,
          name: file.name,
          status: true,
        }),
      }
    );

    const statusData = await statusResponse.json();
    if (statusResponse.ok && statusData.status) {
      console.log("Upload status updated successfully:", statusData);
      return statusData;
    } else {
      console.error("Failed to update upload status:", statusData);
      return null;
    }
  } catch (error) {
    console.error("Error updating upload status:", error);
    throw error;
  }
}

export async function getUserInfo(setUserInfo, setUserInfoLoading) {
  setUserInfoLoading(true);
  try {
    const response = await fetchWithAuth(`/user/info`, {
      method: "GET",
    });
    const data = await response.json();
    await setUserInfo(data?.data);
    localStorage.setItem("userId", JSON.stringify(data?.data?.id));
    localStorage.setItem("userEmail", data?.data?.email);
    localStorage.setItem("showAIModel", data?.data?.showAIModel);
    if (mixpanel?.__loaded) {
      mixpanel.identify(data.data.id);
    }
  } catch (err) {
    console.log(err);
  } finally {
    setUserInfoLoading(false);
  }
}

// export async function createThread(setThreadId) {
//   try {
//     const response = await fetch("https://www.modalx.ai/threads", {
//       method: "POST",
//       credentials: "include",
//       headers: { "Content-Type": "application/json" },
//     });

//     const responseData = await response.json();
//     if (responseData.status) {
//       setThreadId(responseData.data);
//       return responseData.data;
//     } else {
//       throw new Error("Thread creation failed");
//     }
//   } catch (error) {
//     console.error("Thread creation error:", error);
//     return null;
//   }
// }

// // Function to find the URL in the modalX response (temporary, #todo by backend in production)
// const findUrl = (msg) => {
//   const urlRegex = /(https?:\/\/[^']*?\.(mp3|mp4|pptx|jpg|jpeg|png|txt|ppt))/g;
//   const match = urlRegex.exec(msg);
//   return match ? match[1] : null;
// };

// export async function sendMessage(
//   latestEntry,
//   threadId,
//   threadFiles,
//   threadSettings,
//   setThreadId
// ) {
//   const targetThreadId = threadId || (await createThread(setThreadId));
//   if (!targetThreadId) {
//     console.error("No threadId available for sending message.");
//     return;
//   }

//   const synthesiaVideoSettings =
//     threadSettings.synthesiaBackground ||
//     threadSettings.synthesiaAvatar ||
//     threadSettings.synthesiaVoice
//       ? {
//           avatarId: threadSettings.synthesiaAvatar.avatarId
//             ? threadSettings.synthesiaAvatar.avatarId
//             : null,
//           avatarVoiceId: threadSettings.synthesiaVoice.VoiceId
//             ? threadSettings.synthesiaVoice.VoiceId
//             : null,
//           backgroundImageId: threadSettings.synthesiaBackground.imageID
//             ? threadSettings.synthesiaBackground.imageID
//             : null,
//         }
//       : null;

//   const fileIds = threadFiles.map((file) => file.fileId);
//   const currThreadMsg = {
//     content: latestEntry.content,
//     file_ids: fileIds,
//     synthesiaVideoSettings: synthesiaVideoSettings,
//   };

//   try {
//     const response = await fetch(`https://www.modalx.ai/threads/${targetThreadId}/message`, {
//       method: "POST",
//       credentials: "include",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(currThreadMsg),
//     });

//     const responseData = await response.json();

//     if (responseData.status) {
//       const content = responseData.data.content;
//       const url = findUrl(content);
//       const currMsg = {
//         sender: "modalX",
//         content: content,
//         file: url ? { url: url, status: "processing" } : null,
//       };
//       return currMsg;
//     } else {
//       console.error("Failed to process message:", responseData.message);
//       return null;
//     }
//   } catch (error) {
//     console.error("Send message request error:", error);
//     return null;
//   }
// }

// export async function checkUrlStatus(url, threadId) {
//   try {
//     const response = await fetch("https://www.modalx.ai/status", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ threadId, url }),
//     });

//     const responseData = await response.json();
//     if (responseData.data.status === "completed") {
//       return true;
//     } else {
//       return false;
//     }
//   } catch (error) {
//     console.error("Check URL status request error:", error);
//     return null;
//   }
// }

// export async function uploadFiles(fileObj, threadId, setThreadId) {
//   const targetThreadId = threadId || (await createThread(setThreadId));
//   if (!targetThreadId) {
//     console.error("No threadId available for uploading files.");
//     return null;
//   }

//   const formData = new FormData();
//   if (fileObj.type === "link") {
//     formData.append("link", fileObj.link);
//   } else if (fileObj.type === "file") {
//     formData.append("file", fileObj.file);
//   }

//   try {
//     const response = await fetch(
//       `https://www.modalx.ai/threads/fileupload?threadId=${targetThreadId}`,
//       {
//         method: "POST",
//         credentials: "include",
//         body: formData,
//       }
//     );

//     return await response.json(); // Return the entire response object
//   } catch (error) {
//     console.error("Upload file request Error:", error);
//     return null;
//   }
// }

export const fetchAllHistory = async (
  Today,
  setToday,
  setYesterday,
  setThisWeek,
  setThisMonth,
  setPrevMonth,
  setCurrentHistoryId,
  setMonths,
  setYears,
  setHistoryLoading
) => {
  try {
    const res = await axiosInstance.get(`/chat/summary`);
    if (res.data.status) {
      const {
        today,
        yesterday,
        this_week,
        this_month,
        last_month,
        months,
        years,
      } = res.data.data;
      setToday(today || []);
      if (Today.length && Today.length < today.length) {
        localStorage.setItem("current_history_id", today[0].id);
        setCurrentHistoryId(today[0].id);
      }
      setYesterday(yesterday || []);
      setThisWeek(this_week || []);
      setThisMonth(this_month || []);
      setPrevMonth(last_month || []);
      setMonths(months || {});
      setYears(years || {});
    }
  } catch (error) {
    console.error("Error fetching history:", error);
  } finally {
    if (setHistoryLoading) {
      setHistoryLoading(false);
    }
  }
};

export const fetchWebsites = async (setCurrentWebs) => {
  try {
    const res = await axiosInstance.get(`/v1/websiteTrackings/listAll`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    // const sortedData = res.data.data.sort((a, b) => {
    //   if (a.notifications === b.notifications) return 0;
    //   return a.notifications ? -1 : 1;
    // });
    const sortedData = res?.data?.data?.sort((a, b) => {
      // Priority 1: isDefault: true, status: "enabled", notifications: true
      const aPriority1 =
        a?.isDefault === true &&
        a?.status === "enabled" &&
        a?.notifications === true;
      const bPriority1 =
        b?.isDefault === true &&
        b?.status === "enabled" &&
        b?.notifications === true;
      if (aPriority1 && !bPriority1) return -1;
      if (!aPriority1 && bPriority1) return 1;

      // Priority 2: notifications: true, status: "", isDefault: false
      const aPriority2 =
        a?.notifications === true && a?.status === "" && a?.isDefault === false;
      const bPriority2 =
        b?.notifications === true && b?.status === "" && b?.isDefault === false;
      if (aPriority2 && !bPriority2) return -1;
      if (!aPriority2 && bPriority2) return 1;

      // Priority 3: isDefault: true, status: "enabled", notifications: false
      const aPriority3 =
        a?.isDefault === true &&
        a?.status === "enabled" &&
        a?.notifications === false;
      const bPriority3 =
        b?.isDefault === true &&
        b?.status === "enabled" &&
        b?.notifications === false;
      if (aPriority3 && !bPriority3) return -1;
      if (!aPriority3 && bPriority3) return 1;

      // Priority 4: isDefault: false, notifications: false, status: ""
      const aPriority4 =
        a?.isDefault === false &&
        a?.notifications === false &&
        a?.status === "";
      const bPriority4 =
        b?.isDefault === false &&
        b?.notifications === false &&
        b?.status === "";
      if (aPriority4 && !bPriority4) return -1;
      if (!aPriority4 && bPriority4) return 1;

      return 0; // No changes if they have the same priority
    });

    setCurrentWebs(sortedData);
  } catch (error) {
    console.error(error);
  }
};

export const DeleteUploadFileFromS3 = async (fileId) => {
  try {
    const res = await axiosInstance.delete(`/threads/files/${fileId}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return res;
  } catch (error) {
    console.error(error);
  }
};

export const FetchHistoryOfThreadId = async () => {
  const id = localStorage.getItem("current_history_id");
  if (!id || id === 'null' || id === '') {
    return null;
  }
  try {
    const res = await axiosInstance.get(`/chat/${id}/history`);
    return res;
  } catch (error) {
    console.error(error);
  }
};

export const StopResponseGeneration = async (threadId, id) => {
  console.log(threadId, "responseData thread ID");
  console.log(id, "responseDatamessage ID");
  const targetThreadId = threadId;
  const req_target_threadId = targetThreadId.match(/thread-(.*)/)[1];
  const messageId = {
    id: id,
  };
  try {
    const response = await fetchWithAuth(
      `/threads/thread-${req_target_threadId}/message/stop`,
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(messageId),
      }
    );
    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.error(error);
  }
};

export const handleAddCredit = async (setIsLoading, value) => {
  trackButtonEvent("button_click_Upgrade_Plan", {
    button_name: "Upgrade Plan",
    button_position: "Bottom-left",
  });
  SubscribeToProClick();
  setIsLoading(true);

  const body = {
    subscriptioType: value,
  };

  try {
    const response = await fetchWithAuth(`/payment/createCheckoutSession`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    const result = await response.json();

    if (response.ok && result.status) {
      const redirectUrl = result.data.url;
      if (redirectUrl) {
        window.location.href = redirectUrl;
      } else {
        console.error("Redirect URL not found in the response.");
        setIsLoading(false); // Hide loading modal if an error occurs
      }
    } else {
      console.error(
        "Error creating checkout session:",
        result.message || "Unknown error"
      );
      setIsLoading(false); // Hide loading modal if an error occurs
    }
  } catch (error) {
    alert("Create checkout session failed");
    console.error("Error:", error);
    setIsLoading(false); // Hide loading modal if an error occurs
  }
};

export const UserCreaditStatus = async (
  setSubscribe,
  setSubscribeType,
  setShowCallingAgentIconOnWorkspace
) => {
  const isLoggedIn = localStorage.getItem("isLoggedIn");
  if (isLoggedIn) {
    try {
      const response = await axiosInstance.get(`/issubscribe`);
      // if(response.status===200  &&  response.data.data["remaning credits"] === "User is subscribed."){
      //   setSubscribe(true)
      // }
      // console.log(response, "response")
      if (response.status === 200 && response.data?.data?.status === true) {
        setSubscribe(true);
        setSubscribeType(response?.data?.data?.subscriptionType);
        setShowCallingAgentIconOnWorkspace(
          response?.data?.data?.showCallingAgent
        );
      } else if (
        response.status === 200 &&
        response.data?.data?.status === false
      ) {
        setSubscribe(false);
      }
    } catch (e) {
      console.log("User_Creadit_Status", e);
    }
  }
};
export const FetchUserSettings = async () => {
  try {
    const res = await axiosInstance.get(`/user/settings`);
    return res?.data?.data;
  } catch (error) {
    console.error(error);
  }
};

export const AddAndDeleteFree = async (email, status) => {
  const userData = {
    email: email,
    isEnabled: status,
  };
  try {
    const res = await axiosInstance.post(`/admin/free-trial`, userData);
    console.log(res.data);
    return res?.data;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export function containsMediaFile(inputString) {
  const mediaFileRegex =
    /(https?:\/\/[^\s]+?\.(jpeg|jpg|png|gif|mp3|mp4|pdf|docx|txt|zip|rar|ppt|pptx))/gi;
  const websiteRegex = /(https?:\/\/[^\s]+)|(www\.[^\s]+)/gi;
  if (mediaFileRegex.test(inputString)) {
    return true; // Media file link found
  }
  // Check if the string contains a general website link
  if (websiteRegex.test(inputString)) {
    return false; // General website link found
  }
  return false;
}

export const DeleteAvatar = async (id) => {
  try {
    const res = await axiosInstance.delete(`/video/avatar/${id}`);
    console.log(res.data);
    return res?.data;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const handleMasterAccess = async (email) => {
  try {
    const res = await axiosInstance.get(
      `/admin/masterLogin?email=${email}`
    );
    // console.log(res.data)
    return res?.data;
  } catch (error) {
    // console.error(error);
    return error;
  }
};

export const setProfileForCalligAgent = async (data) => {
  try {
    const res = await fetchWithAuth(`/callingAgent/profile`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const getProfileForCalligAgent = async () => {
  try {
    const res = await fetchWithAuth(`/callingAgent/profile`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    // console.log(res)
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const updateProfileForCalligAgent = async (id, data) => {
  try {
    const res = await fetchWithAuth(`/callingAgent/profile/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    // console.log(res)
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const getLLMAgentForCalligAgent = async (page) => {
  try {
    const res = await fetchWithAuth(
      `/callingAgent/llm?page=${page}&pagesize=10`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    // console.log(res)
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const AddLLMAgentForCallingAgent = async (data) => {
  try {
    const res = await fetchWithAuth(`/callingAgent/llm`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    // console.log(res)
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const DeleteLLMAgentForCallingAgent = async (id) => {
  try {
    const res = await fetchWithAuth(
      `/callingAgent/llm/${id}?user_agree=true`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const getLLMAgentbyIdForCallingAgent = async (id) => {
  try {
    const res = await fetchWithAuth(`/callingAgent/llm/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const UpdateLLMAgentbyIdForCallingAgent = async (id, updatedData) => {
  try {
    const res = await fetchWithAuth(`/callingAgent/llm/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(updatedData),
    });
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const getVoiceAgentForCalligAgent = async (page) => {
  try {
    const res = await fetchWithAuth(
      `/callingAgent/voiceAgent?page=${page}&pagesize=10`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    // console.log(res)
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const AddVoiceAgentForCallingAgent = async (data) => {
  try {
    const res = await fetchWithAuth(`/callingAgent/voiceAgent`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    // console.log("ressssssssssss", res)
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const DeleteVoiceAgentForCallingAgent = async (id) => {
  try {
    const res = await fetchWithAuth(`/callingAgent/voiceAgent/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const getVoiceAgentbyIdForCallingAgent = async (id) => {
  try {
    const res = await fetchWithAuth(`/callingAgent/voiceAgent/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const UpdateVoiceAgentbyIdForCallingAgent = async (id, updatedData) => {
  try {
    const res = await fetchWithAuth(`/callingAgent/voiceAgent/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(updatedData),
    });
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const getDashboardData = async () => {
  try {
    const res = await fetchWithAuth(`/callingAgent/dashboard`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const getBlockNumberDataForCallingAgent = async (id, currentPage) => {
  try {
    const res = await fetchWithAuth(
      `/callingAgent/voiceAgent/${id}/blocklist?page=${currentPage}&pagesize=5`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const AddNumberInBlockListForCallingAgent = async (id, data) => {
  try {
    const res = await fetchWithAuth(
      `/callingAgent/voiceAgent/${id}/blocklist`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }
    );
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const DeleteNumberInBlockListbyIdForCallingAgent = async (
  id,
  numberId,
  data
) => {
  try {
    const res = await fetchWithAuth(
      `/callingAgent/voiceAgent/${id}/blocklist/${numberId}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const getVoiceAgentPersonaForCallingAgent = async () => {
  try {
    const res = await fetchWithAuth(`/callingAgent/voicePersona`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const getVoiceAgentPhoneNumberForCallingAgent = async () => {
  try {
    const res = await fetchWithAuth(
      `/callingAgent/voiceAgent/phoneNumber`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const getVoiceAgentLanguageForCallingAgent = async () => {
  try {
    const res = await fetchWithAuth(`/callingAgent/voiceLanguage`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const GetSessionDataForVoiceAgentbyIdForCallingAgent = async (
  id,
  page
) => {
  try {
    const res = await fetchWithAuth(
      `/callingAgent/session/voiceAgent/${id}?page=${page}&pagesize=10`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const getContactAgentForCalligAgent = async (page, pageSize) => {
  try {
    const res = await fetchWithAuth(
      `/callingAgent/contacts?page=${page}&pagesize=${pageSize}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    // console.log(res)
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const AddContactAgentForCallingAgent = async (data) => {
  try {
    const res = await fetchWithAuth(`/callingAgent/contacts`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    // console.log(res)
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const DeleteConatctAgentForCallingAgent = async (id) => {
  try {
    const res = await fetchWithAuth(`/callingAgent/contacts/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const getContactAgentbyIdForCallingAgent = async (id) => {
  try {
    const res = await fetchWithAuth(`/callingAgent/contacts/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const UpdateContactAgentbyIdForCallingAgent = async (
  id,
  updatedData
) => {
  try {
    const res = await fetchWithAuth(`/callingAgent/contacts/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(updatedData),
    });
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const GetDetailContactAgentbyIdForCallingAgent = async (id, page) => {
  try {
    const res = await fetchWithAuth(
      `/callingAgent/session/contact/${id}?page=${page}&pagesize=10`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const GetDetailVoiceAgentbyIdForCallingAgent = async (id, page) => {
  try {
    const res = await fetchWithAuth(
      `/callingAgent/session/voiceAgent/${id}?page=${page}&pagesize=10`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const getUsageDataForCallingAgent = async () => {
  try {
    const res = await fetchWithAuth(`/callingAgent/credits`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const uploadContactsCSVFile = async (
  file,
  triggerCall = true,
  batchCount = 100
) => {
  const formData = new FormData();
  formData.append("trigger_call", triggerCall);
  formData.append("file", file);
  console.log("formData", formData);
  try {
    const response = await fetchWithAuth(`/contacts/upload`, {
      method: "POST",
      body: formData,
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || "Upload failed");
    }
    console.log("Upload success:", data);
    return data;
  } catch (error) {
    console.error("Upload error:", error);
    throw error;
  }
};

export const requestACallFromContact = async (data) => {
  try {
    const res = await fetchWithAuth(`/callingAgent/triggerCall/contact`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const requestACallFromVoiceAgent = async (data) => {
  try {
    const res = await fetchWithAuth(
      `/callingAgent/triggerCall/voiceagent`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }
    );
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const requestBulkCallFromContact = async (data) => {
  try {
    const res = await fetchWithAuth(
      `/callingAgent/triggerCall/contact/bulk`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }
    );
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const requestBulkDeleteFromContact = async (data) => {
  try {
    const res = await fetchWithAuth(`/callingAgent/contacts/bulk`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const createBlog = async (formData) => {
  try {
    const response = await fetchWithAuth(`/admin/createBlogs`, {
      method: "POST",
      body: formData,
    });

    if (!response.status) {
      const errorData = await response.json();
      throw new Error(errorData?.message || "Failed to create blog");
    }
    return response;
  } catch (error) {
    console.error("Error submitting blog:", error);
    throw error;
  }
};

export const fetchBlogs = async () => {
  try {
    const response = await fetchWithAuth(`/admin/fetchBlogs`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.status) {
      const errorData = await response.json();
      throw new Error(errorData?.message || "Failed to fetch blogs");
    }
    return response;
  } catch (error) {
    console.error("Error fetching blogs:", error);
    throw error;
  }
};

export const ResendVerificationEmail = async (data) => {
  try {
    const res = await fetchWithAuth(`/resendVerificationEmail`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const FetchAllAvatarsForHeygen = async (currentpage, gender) => {
  try {
    const res = await fetchWithAuth(
      `/video/listavatars?page=${currentpage}&pagesize=8&gender=${gender}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const FetchAllAvatarsLooks = async (groupId) => {
  try {
    const res = await fetchWithAuth(
      `/video/listavatarlooks?groupId=${groupId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const FetchAllAvatarLooks = async (groupId) => {
  try {
    const res = await fetchWithAuth(
      `/video/listavatarlooks?groupId=${groupId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const FetchAllVoicesForHeygen = async (currentPage, gender) => {
  try {
    const res = await fetchWithAuth(
      `/video/listVoices?page=${currentPage}&pagesize=10&gender=${gender}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const FetchAllHeygenVoicesForSettings = async () => {
  try {
    const res = await fetchWithAuth(`/video/listVoices`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const UploadPersonalPhotoForHeygen = async (data) => {
  try {
    const res = await fetchWithAuth(`/video/uploadPersonalPhoto`, {
      method: "POST",
      body: data,
    });
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const CreateAvatarByImage = async (data) => {
  try {
    const res = await fetchWithAuth(`/video/AvatarGroup`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const GetPersonalAvatarData = async () => {
  try {
    const res = await fetchWithAuth(`/video/AvatarGroup`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const GenerateAvatarPhotosForHeygen = async (data) => {
  try {
    const res = await fetchWithAuth(`/video/generateAvatarPhotos`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const DeleteAvatarForHeygen = async (group_id) => {
  try {
    const res = await fetchWithAuth(
      `/video/AvatarGroup?group_id=${group_id}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const FetchLookToAvatar = async (id) => {
  try {
    const res = await fetchWithAuth(`/video/AvatarGroup?group_id=${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const AddLookToAvatar = async (data) => {
  try {
    const res = await fetchWithAuth(`/video/AvatarGroup/AddImage`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const DeleteLookToAvatar = async (id) => {
  try {
    const res = await fetchWithAuth(`/video/Avatar?avatar_id=${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!res.status) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Something went wrong");
    }
    return res;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const generateAvatarPhotos = async ({
  name,
  age,
  gender,
  ethnicity,
  orientation,
  pose,
  style,
  appearance,
}) => {
  try {
    const response = await fetchWithAuth(`/video/generateAvatarPhotos`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name,
        age,
        gender,
        ethnicity,
        orientation: orientation.toLowerCase(), // Convert to lowercase to match API expectations
        pose: pose.toLowerCase().replace(" ", "_"), // Convert to lowercase and replace spaces with underscores
        style,
        appearance,
      }),
    });

    if (!response.ok) {
      throw new Error(`API request failed with status ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error generating avatar photos:", error);
    throw error;
  }
};

export const checkPhotoGenerationStatus = async (generationId) => {
  try {
    const response = await fetchWithAuth(
      `/video/checkPhotoGenerationStatus`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          generation_id: generationId,
        }),
      }
    );

    if (!response.ok) {
      throw new Error(`API request failed with status ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error checking generation status:", error);
    throw error;
  }
};

// Polling function that will check status periodically
export const pollGenerationStatus = async (
  generationId,
  interval = 2000,
  timeout = 6000000
) => {
  const startTime = Date.now();

  return new Promise((resolve, reject) => {
    const checkStatus = async () => {
      try {
        const response = await checkPhotoGenerationStatus(generationId);

        // Check if the response indicates success
        if (response.data?.data?.status === "success") {
          // Return the full response so we can access image_url_list
          resolve(response.data.data);
          return;
        }
        // Check if the response indicates failure
        else if (response.data?.data?.status === "failed") {
          reject(new Error(response.data?.data?.msg || "Generation failed"));
          return;
        }
        // Check if timeout has been reached
        else if (Date.now() - startTime > timeout) {
          reject(new Error("Generation timeout"));
          return;
        }
        // If still processing, schedule next check
        setTimeout(checkStatus, interval);
      } catch (error) {
        // Handle CORS errors specifically
        if (
          error.message.includes("Failed to fetch") ||
          error.message.includes("CORS")
        ) {
          console.warn("CORS issue detected, retrying...");
          // Only retry if we haven't timed out yet
          if (Date.now() - startTime < timeout) {
            setTimeout(checkStatus, interval);
          } else {
            reject(new Error("Generation timeout during CORS retries"));
          }
        } else {
          reject(error);
        }
      }
    };

    // Start the polling
    checkStatus();
  });
};

export const createAvatarGroup = async (imageKey, name) => {
  try {
    const response = await fetchWithAuth(`/video/AvatarGroup`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        image_key: imageKey,
        name: name,
      }),
    });

    if (!response.ok) {
      throw new Error(`API request failed with status ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error creating avatar group:", error);
    throw error;
  }
};

export const DownloadCSVFileForContact = async (
  contact_id,
  start_date,
  end_date
) => {
  let urlForFetch;
  if (start_date && end_date) {
    urlForFetch = `/callingAgent/export?contact_id=${contact_id}&start_date=${start_date}&end_date=${end_date}`;
  } else {
    urlForFetch = `/callingAgent/export?contact_id=${contact_id}`;
  }
  try {
    const response = await fetchWithAuth(urlForFetch, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (error) {
    console.error("Error creating avatar group:", error);
    throw error;
  }
};

export const DownloadCSVFileForAgent = async (
  agent_id,
  start_date,
  end_date
) => {
  let urlForFetch;
  if (start_date && end_date) {
    urlForFetch = `/callingAgent/export?agent_id=${agent_id}&start_date=${start_date}&end_date=${end_date}`;
  } else {
    urlForFetch = `/callingAgent/export?agent_id=${agent_id}`;
  }
  try {
    const response = await fetchWithAuth(urlForFetch, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (error) {
    console.error("Error downloading CSV file:", error);
    throw error;
  }
};

export const DownloadCSVFileForAdmin = async (email, start_date, end_date) => {
  let urlForFetch;
  if (start_date && end_date) {
    urlForFetch = `/admin/callingAgent/export?email=${email}&start_date=${start_date}&end_date=${end_date}`;
  } else {
    urlForFetch = `/admin/callingAgent/export?email=${email}`;
  }
  try {
    const response = await fetchWithAuth(urlForFetch, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (error) {
    console.error("Error downloading CSV file:", error);
    throw error;
  }
};

// workspaceUtils.js
export const saveEditedImage = async (
  imageBlob,
  messageId,
  imageId,
  chatId
) => {
  try {
    const formData = new FormData();

    // 1. Add the binary image file (matches curl's --form 'image=@file.jpg')
    formData.append("image", imageBlob, "edited-image.jpg");

    // 2. Add metadata fields (exactly as in curl example)
    formData.append("message_id", messageId);
    formData.append("image_id", imageId);
    formData.append("chat_id", chatId);

    const response = await fetchWithAuth(`/images/edit`, {
      method: "POST",
      body: formData,
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        errorData.message || `HTTP error! status: ${response.status}`
      );
    }

    return await response.json();
  } catch (error) {
    console.error("Error saving edited image:", error);
    throw error;
  }
};
